import React from "react";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { whatsappLink } from "../lib/api";

const HIDDEN_ON = ["/admin", "/checkout"];

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  if (HIDDEN_ON.some((p) => pathname.startsWith(p))) return null;

  // On product detail pages, mobile has a sticky bottom buy bar — lift the button above it.
  const isProductDetail = pathname.startsWith("/product/");

  return (
    <a
      data-testid="whatsapp-floating"
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className={`group fixed right-4 sm:right-6 z-30
        ${isProductDetail ? "bottom-24 sm:bottom-6" : "bottom-20 sm:bottom-6"}
        flex items-center gap-2
        bg-[#25D366]/90 hover:bg-[#1ebe5b]
        text-white
        rounded-full
        shadow-lg shadow-black/40 backdrop-blur-sm
        h-12
        pl-3 pr-3
        transition-all duration-300 ease-out
        sm:hover:pr-5`}
    >
      <MessageCircle size={20} className="shrink-0" />
      <span
        className="hidden sm:inline-block overflow-hidden whitespace-nowrap
                   max-w-0 group-hover:max-w-[120px]
                   transition-[max-width] duration-300 ease-out
                   text-[11px] font-display tracking-[0.2em] uppercase"
      >
        Chat
      </span>
    </a>
  );
}
